import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { flatMap } from 'rxjs/operators';
import { SettlementHaltedDialogComponentData, SettlementHaltedDialogResponse } from '../components/aftale/models';
import { EGIS_SERVICE_CALLER } from '../constants';
import { SettlementHaltedDialogComponent } from '../component/afregning/settlement-halted-dialog/settlement-halted-dialog.component';
import { FejlDashbordRetFejlRequest } from '../api/models/OK/Egis/Service/Models/Request/fejl-dashbord-ret-fejl-request';
import { FejlDashboardTypeEnum } from '../api/models/OK/Egis/Service/Models/DTO/Enums/fejl-dashboard-type-enum';
import { FejlDashboardService } from 'src/app/api/services/fejl-dashboard.service';

@Injectable({
  providedIn: 'root',
})
export class SettlementService {
  constructor(
    private dialog: MatDialog,
    private fejlDashboardService: FejlDashboardService,
  ) {}

  settlementHalted$(
    settlementId: number,
    errorTextG4: string,
    isCreditnote: boolean,
    creditnoteBilagsnr?: number,
    creditnoteOpkraevningDate?: Date,
    agreementNo?: number,
    serviceorderNo?: number,
    amountExclVat?: number,
    amountInclVat?: number,
  ): Observable<any> {
    let data: SettlementHaltedDialogComponentData = {
      settlementId: settlementId,
      agreementNo: agreementNo,
      serviceorderNo: serviceorderNo,
      errorTextG4: errorTextG4,
      isCreditnote: isCreditnote,
      creditnoteBilagsnr: creditnoteBilagsnr,
      creditnoteOpkraevningDate: creditnoteOpkraevningDate,
      amountExclVat: amountExclVat,
      amountInclVat: amountInclVat,
    };
    let dialogRef = this.dialog.open(SettlementHaltedDialogComponent, {
      data: data,
    });

    return dialogRef.afterClosed().pipe(
      flatMap((result: SettlementHaltedDialogResponse) => {
        if (!result.settlementId) {
          return of(null);
        }
        const request: FejlDashbordRetFejlRequest = {
          fejlDashboardType: FejlDashboardTypeEnum.AfregningerHalted,
          ids: [],
          settlementId: result.settlementId,
          g4AfregningerHaltedAction: result.g4AfregningerHaltedActionEnum,
          creditnoteBilagsnr: result.creditnoteBilagsnr !== undefined ? result.creditnoteBilagsnr : null,
          creditnoteOpkraevningDate:
            result.creditnoteOpkraevningDate !== undefined ? result.creditnoteOpkraevningDate.toOkDateString() : null,
        };
        return this.fejlDashboardService.retFejlDashboardListe({ caller: EGIS_SERVICE_CALLER, body: request });
      }),
    );
  }
}
